//
//
//
//
//
//
//
//
//
//

// import vueTouch from "@/assets/utils/vueTouch.js";
import wx from "@/assets/utils/wx.js";
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
  created() {
    // 微信jssdk 配置
    wx.wxConfig(
      false,
      {
        title: "诗画浙江全域导览", // 分享标题
        link: window.location.href, // 分享链接
        desc: window.location.href, // 分享描述
        imgUrl: "", // 分享图标
      },
      function () {
        //分享成功后的回调函数
        console.log("分享成功");
      }
    );
  },
};



// WEBPACK FOOTER //
// ./src/App.vue